module.exports = __webpack_public_path__ + "img/H000070_windmill.d3c7d001.png";